import styled, { css } from 'styled-components'
import type { TableHeadProps } from './types'

export const Container = styled.div<Pick<TableHeadProps, '$compact'>>`
  display: flex;
  flex-direction: row;
  background: var(--bg-transparent);
  padding: 0 var(--space-200);
  border: 1px solid var(--border-secondary);
  border-top-left-radius: var(--radius-brand);
  border-top-right-radius: var(--radius-brand);

  ${({ $compact }) =>
    $compact &&
    css`
      line-height: var(--font-line-height-100);
    `}
`

export const SortableCell = styled.div`
  width: 48px;
`
